export enum NotificationFilterEnum {
  READ = 'READ',
  UNREAD = 'UNREAD',
  ALL = 'ALL'
}
